import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoginClaimsState } from 'src/modules/security/states/login-claims/login-claims.state';
import { NavigateToPatients } from 'src/app/states/navigations.actions';

export const pscGuard: CanActivateFn = () => {
  const store = inject(Store);

  const isPsc = store.selectSnapshot(LoginClaimsState.isPsc);

  if (!isPsc) {
    store.dispatch(new NavigateToPatients());
  }

  return isPsc;
};
